import React, { FC } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAppSelector } from 'reduxState/hooks';
import { campaignsNavTab } from './constants';
import { selectUserRestrictedRole } from 'reduxState/store/user/selectors';
import { hasWildfirePermissionsSelector } from 'helpers/auth0';
import { appGroupDefaultNavTabs, defaultNavigationTabs, NavTab, getRestrictedRoleTabs } from './constants';
import './NavTabs.scss';

interface NavTabsProps {
  appId?: string;
  adminAppId: string;
}

const NavTabs: FC<NavTabsProps> = ({ appId, adminAppId }) => {
  const location = useLocation();
  const theme = useTheme();
  const { user } = useAuth0();
  const isInSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const restrictedRole = useAppSelector(selectUserRestrictedRole);
  const hasWFPermissions = hasWildfirePermissionsSelector(user);

  const restrictedUserRoleTabs = restrictedRole !== null ? getRestrictedRoleTabs(restrictedRole, !!appId) : null;

  const renderTabs = () => {
    const renderTab = (tab: NavTab) => {
      if (appId) {
        return (
          <Link
            key={tab.name}
            to={`/${adminAppId}/app/${appId}/${tab.pathname}`}
            className={`tab ${location.pathname.includes(tab.pathname) ? 'active' : ''}`}
          >
            {tab.name}
          </Link>
        );
      } else {
        return (
          <Link
            key={tab.name}
            to={`/${adminAppId}/${tab.pathname}`}
            className={`tab ${location.pathname.includes(tab.pathname) ? 'active' : ''}`}
          >
            {tab.name}
          </Link>
        );
      }
    };

    if (restrictedRole && restrictedUserRoleTabs) return restrictedUserRoleTabs?.map(renderTab);
    // If appId exists render tabs for single application
    // If not render tabs for app group
    if (appId) {
      return defaultNavigationTabs.map(renderTab);
    } else {
      // Only render Campaigns tab if use hasWFPermissions
      if (hasWFPermissions) {
        return [...appGroupDefaultNavTabs, campaignsNavTab].map(renderTab);
      }
      return appGroupDefaultNavTabs.map(renderTab);
    }
  };

  return !isInSmallScreen ? <div className="tab-list">{renderTabs()}</div> : <></>;
};

export default NavTabs;
